import SurveysShow from "../components/surveys/Show";

export default [
  { name: 'Surveys', path: '/surveys', component: SurveysShow,  }
]
